import { FieldViewModel } from "../../omnia";

export type ResetCroppingVm = ReturnType<typeof getResetCroppingVm>

export function getResetCroppingVm(cropping: FieldViewModel, _inNutritionPlans: boolean) {

    return {

        get croppingId(): number {
            return cropping.croppingId;
        },

        get inNutritionPlans(): boolean {
            return _inNutritionPlans;
        },

        get cssColor() {
            return cropping.cssColor;
        },

        get description(): string {
            return cropping.description;
        },

    }

}
